import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../Services/apiService";

export const GetValidationTasks = createAsyncThunk(
  "ValidationWorkFlow/ValidationTasks",
  async (validateModel, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/ValidationWorkFlow/ValidationTasks",
        {
          mainTaskGuid: validateModel.mainTaskGuid,
          subTasksGuid: validateModel.subTasksGuid,
          typeTasks: validateModel.typeTasks,
          actionGuid: validateModel.actionGuid,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //   if (response.data.success === true) {
      //     const arrayValidate = response.data.result.map((ele, ind) => {
      //       return ele.code;
      //     });
      //     return arrayValidate; // Return the extracted data
      //   }
      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const ValidationTasksManager = createSlice({
  name: "ValidationTasksManager",
  initialState: {
    ValidationTasksManager: {},
    loadingValidationTasksManager: false,
    errorValidationTasksManager: null,
  },
  reducers: {
    SetValidationTasksManager: (state, action) => {
      state.ValidationTasksManager = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(GetValidationTasks.pending, (state, action) => {
        state.loadingValidationTasksManager = true;
        state.ValidationTasksManager = action.payload;
        state.errorValidationTasksManager = null;
      })
      .addCase(GetValidationTasks.fulfilled, (state, action) => {
        state.loadingValidationTasksManager = false;
        state.ValidationTasksManager = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetValidationTasks.rejected, (state, action) => {
        state.loadingValidationTasksManager = false;
        state.errorValidationTasksManager = action.payload;
      });
  },
});
export const { SetValidationTasksManager } = ValidationTasksManager.actions;

export default ValidationTasksManager.reducer;
